var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.3805 2.22125H25.3162L16.7178 12.0487L26.8332 25.4215H18.9129L12.7095 17.311L5.61144 25.4215H1.67334L10.8702 14.91L1.1665 2.22125H9.2878L14.8951 9.63464L21.3805 2.22125ZM19.9992 23.0658H22.18L8.1028 4.45324H5.76254L19.9992 23.0658Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.827518fc8fe23fec5fb0091bd497e7f4.svg";
export { ForwardRef as ReactComponent };